"use client";

import { X } from "lucide-react";
import { products, services, solutions } from "@latam-energy/content";
import { useMemo, useState } from "react";
import { AppLink as Link } from "./AppLink";

const items = [
  ...services.map((item) => ({ label: item.title, href: `/servicios/${item.slug}`, text: item.summary })),
  ...solutions.map((item) => ({ label: item.title, href: `/soluciones/${item.slug}`, text: item.summary })),
  ...products.map((item) => ({ label: item.name, href: `/productos/${item.slug}`, text: item.shortDescription }))
];

export function SearchDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [query, setQuery] = useState("");
  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items.slice(0, 6);
    return items.filter((item) => `${item.label} ${item.text}`.toLowerCase().includes(q)).slice(0, 8);
  }, [query]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-navy/70 p-4" role="dialog" aria-modal="true" aria-label="Búsqueda del sitio">
      <div className="mx-auto mt-16 max-w-2xl rounded-lg bg-white p-5 shadow-industrial">
        <div className="flex items-center justify-between gap-4">
          <h2 className="text-xl font-extrabold text-navy">Buscar</h2>
          <button className="btn btn-outline px-3" aria-label="Cerrar búsqueda" onClick={onClose}><X size={20} /></button>
        </div>
        <label className="mt-4 block text-sm font-bold text-steel" htmlFor="site-search">Texto de búsqueda</label>
        <input id="site-search" autoFocus className="mt-2 w-full rounded-md border border-slate-300 p-3" value={query} onChange={(event) => setQuery(event.target.value)} />
        <div className="mt-5 grid gap-3">
          {results.length ? results.map((item) => (
            <Link key={item.href} className="rounded-md border border-slate-200 p-4 hover:border-cyan" href={item.href} onClick={onClose}>
              <strong className="text-navy">{item.label}</strong>
              <span className="mt-1 block text-sm text-slate-600">{item.text}</span>
            </Link>
          )) : <p className="rounded-md bg-slate-100 p-4 text-slate-600">No se encontraron resultados.</p>}
        </div>
      </div>
    </div>
  );
}
